/**
 * AdditionalInfoSection - Indemnitor info and additional notes
 */

import { OathInput } from '../../../../shared/OathUI';
import { formatPhoneNumber, unformatPhone } from '../../shared/formatUtils';

const AdditionalInfoSection = ({ formState, dispatch }) => {
  const set = (field) => (val) => dispatch({ type: 'SET_FIELD', field, value: val });

  return (
    <div>
      <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-3">Indemnitor & Additional Info</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <OathInput
          label="Indemnitor Name"
          value={formState.indemnitorName}
          onChange={set('indemnitorName')}
          placeholder="Name of person signing"
        />
        <OathInput
          label="Indemnitor Phone"
          value={formatPhoneNumber(formState.indemnitorPhone)}
          onChange={(val) => dispatch({ type: 'SET_FIELD', field: 'indemnitorPhone', value: unformatPhone(val) })}
          placeholder="(555) 123-4567"
        />
        <div className="sm:col-span-2">
          <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
            Additional Information
          </label>
          <textarea
            value={formState.additionalInfo}
            onChange={(e) => dispatch({ type: 'SET_FIELD', field: 'additionalInfo', value: e.target.value })}
            placeholder="Any special instructions for the posting agent"
            className="w-full px-4 py-3.5 border border-gray-300 dark:border-gray-600 rounded-xl text-base sm:text-sm text-gray-900 dark:text-white bg-white dark:bg-gray-700 focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all duration-200 placeholder:text-gray-400 dark:placeholder:text-gray-500 resize-none"
            rows={3}
          />
        </div>
      </div>
    </div>
  );
};

export default AdditionalInfoSection;
